module.exports = __webpack_public_path__ + "static/media/shapes.1cacee00.svg";